import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { PayLoadData } from 'src/Shared/model/PayLoadData';
import { retry, catchError } from 'rxjs/operators';
import { VisitingCardResponse } from '../model/VisitingCardResponse';
import { ApproveResponseDetails } from '../model/ApproveResponseDetails';

@Injectable({
  providedIn: 'root'
})
export class DecryptionService {
  baseurl = environment.ApiUrl;
  constructor(private http: HttpClient) { }
  // Http Headers
  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  httpOptions = {
    headers: this.httpHeaders
  };

  Decryption(data): Observable<PayLoadData> {
    console.log(data);
    jsondata: String;
    jsondata: JSON.stringify(data);
    return this.http.post<PayLoadData>(this.baseurl + 'Auth/Decryption', JSON.stringify(data), this.httpOptions)
      .pipe(
        retry(0),
        catchError(this.errorHandle)
      )
  }
  fetchUploadedData(data): Observable<ApproveResponseDetails[]> {
    
    jsondata: String;
    jsondata: JSON.stringify(data);
    return this.http.post<ApproveResponseDetails[]>(this.baseurl + 'Visiting/GetApproveDetails', JSON.stringify(data), this.httpOptions)
      .pipe(
        retry(0),
        catchError(this.errorHandle)
      )
  }

  SaveRequest(data): Observable<VisitingCardResponse> {
    
    jsondata: String;
    jsondata: JSON.stringify(data);
    return this.http.post<VisitingCardResponse>(this.baseurl + 'Visiting/SaveRequest', JSON.stringify(data), this.httpOptions)
      .pipe(
        retry(0),
        catchError(this.errorHandle)
      )
  }




  // Error handling
  errorHandle(error) {
    console.log(error);
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
